module.exports = __webpack_public_path__ + "img/logo.35eef7e6.png";